<template>
  <!-- 权限历史记录-->
  <el-container class="permission-blacklist pagination-list">
    <el-main>
      <div class="content">
        <div class="permission-blacklist-search">
          <el-input v-model="keyWord" clearable placeholder="请输入姓名/权限进行查询" @keydown.native.enter="search(true)"></el-input>
          <el-button class="button-border" @click="search(true)" style="margin-top: 1px" size="mini">查询</el-button>
          <el-button class="button-solid" @click="add(true)" style="margin-top: 1px" size="mini">添加黑名单</el-button>
        </div>
        <div class="log-table">
          <el-table
            class="table-list"
            v-loading="loadingBlackList"
            height="100%"
            :data="data"
            highlight-current-row>
            <el-table-column
              show-overflow-tooltip
              v-for="column in columns"
              :label="column.label"
              :key="column.prop"
              :prop="column.prop"
              align="center"
            >
            </el-table-column>
            <el-table-column
              label="操作列"
              align="center">
              <template slot-scope="scope">
                <el-button @click="setupClick(scope, scope.row)" type="text" size="small">设置</el-button>
                <span @click="relieveDialogClick(scope, scope.row)" :class="scope.row.id === addDialogData.deleteId ? 'blue-text-button' : 'gray-text-button'">解除黑名单</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-footer">
          <el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            layout="total, prev, pager, next, sizes"
            :currentPage="pagination.currentPage"
            :total="pagination.total"
            :page-size="pagination.pageSize"
            background
          >
          </el-pagination>
        </div>
      </div>
      <el-dialog
        class="permission-blacklist-dialog"
        :visible.sync="addDialogVisible"
        :title="addDialogData.title"
        width="450px"
        center
        @close="cancleAdd"
        :close-on-click-modal="false"
        :close-on-press-escape="false">
        <div class="add-blacklist">
          <span>菜单权限</span>
          <el-button type="text" @click="addMenu">请选择</el-button>
          <span>{{addDialogData.menuData}}</span>
        </div>
        <div class="add-blacklist">
          <span>禁止对象</span>
          <el-button type="text" @click="addPerson">请选择</el-button>
          <span>{{addDialogData.personData}}</span>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button class="permission-blacklist-button" @click="saveBlacklistClick" :loading="saveBlacklistLoading">保存</el-button>
          <el-button @click="cancleAdd">取消</el-button>
        </div>
      </el-dialog>
      <el-dialog
        class="permission-blacklist-menu-dialog"
        :visible.sync="menuDialogVisible"
        title="添加权限"
        width="35%"
        center
        @close="cancelAddMenu"
        :close-on-click-modal="false"
        :close-on-press-escape="false">
        <el-input class="permission-blacklist-search-input" placeholder="请输入权限名称" v-model="filterMenuText" clearable>
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <div class="permission-blacklist-divide" @click="openMenu = !openMenu"><i :class="openMenu ? ['el-icon-caret-right', 'expanded', 'el-tree-node__expand-icon'] : ['el-icon-caret-right', 'el-tree-node__expand-icon']"></i><span>菜单权限</span></div>
        <el-tree
          v-if="openMenu"
          ref="menuTree"
          v-loading="loadingMenu"
          element-loading-text="加载中..."
          element-loading-spinner="el-icon-loading"
          node-key="id"
          :check-strictly="loadingMenu || isSelectingParent"
          :data="menuListObj"
          :props="menuTreeProps"
          :default-expanded-keys="getExpandedKey"
          :filter-node-method="filterNodeMenu"
          show-checkbox
          @check="(data, checked) => handleMenuChecked(data, checked)">
        </el-tree>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveMenuClick" :loading="loading2">保存</el-button>
          <el-button @click="cancelAddMenu">取消</el-button>
        </div>
      </el-dialog>
      <el-dialog
        class="permission-blacklist-person-dialog"
        :visible.sync="personDialogVisible"
        title="添加成员"
        width="37%"
        center
        :close-on-click-modal="false"
        :close-on-press-escape="false">
        <el-tabs v-model="activeTabName" type="border-card" @tab-click="handleTabChange">
          <el-tab-pane label="人员部门"  name="people&department">
            <div class="people-department-content">
              <div class="pd-content">
                <div class="pd-content-left custom-tree">
                  <div class="pd-content-left-search">
                    <el-input placeholder="搜索部门 / 人员" prefix-icon="el-icon-search" v-model="filterText"></el-input>
                  </div>
                  <el-tree
                    :data="nodeList"
                    show-checkbox
                    node-key="id"
                    ref="dialogTree"
                    :filter-node-method="filterNode"
                    empty-text=""
                    :check-strictly="true"
                    :props="defaultProps"
                    @check-change="dialogNodeClick">
                    <span slot-scope="{ node, data }">
                      <i :class="[data.type === 'user' ? 'el-icon-user' : 'el-icon-folder']"></i>
                      {{node.label}}
                    </span>
                  </el-tree>
                </div>
                <div class="pd-content-right">
                  <div class="pd-content-title">
                    <h4>已选择</h4>
                  </div>
                  <div class="show-select-label">
                    <template v-for="item in pdSelected">
                      <p :key="item.id"><i :class="[item.groupType === '人员' ? 'el-icon-user' : 'el-icon-folder']"></i>{{ item.name }}<i @click="deleteRoleMember(item)" class="el-icon-error"></i></p>
                    </template>
                  </div>
                </div>
              </div>
              <div slot="footer" class="dialog-footer">
                <div class="dialog-operation">
                  <div class="btn">
                    <el-button @click="cancelAddMember">取消</el-button>
                    <el-button type="primary" @click="saveSelectedMember" :loading="isSaveMember">保存</el-button>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="岗位" name="post">
            <div class="post-content">
              <el-form
                :inline="true"
                :model="formData.addPostFormData"
                @submit.native.prevent
              >
                <el-form-item label="关键字">
                  <el-input placeholder="请输入名称/部门" v-model="formData.addPostFormData.name"></el-input>
                </el-form-item>
                <el-form-item label="所属分类">
                  <el-select v-model="formData.addPostFormData.category" placeholder="请选择所属分类">
                    <el-option
                      v-for="item in postClissifyList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button class="add-post-search change-border-color" @click="searchAddPostList">查询</el-button>
                </el-form-item>
              </el-form>
              <div class="add-post-table">
                <el-table
                  v-loading="formData.addPostFormData.isLoadPosts"
                  height="400"
                  :header-cell-class-name="cellClass"
                  :data="tableData.addPostData"
                  ref="postTable"
                  row-key="id"
                  @select="handleSelectionChange"
                  @row-click="handleRowClick"
                >
                  <el-table-column type="selection" reserve-selection min-width="100" align="center" :resizable="false"></el-table-column>
                  <el-table-column
                    v-for="column in tableData.addPostColumnData"
                    :prop="column.prop"
                    :key="column.prop"
                    :label="column.label"
                    :resizable="column.resizable"
                    :show-overflow-tooltip="true"
                    :align="column.align"
                    min-width="100"
                    v-cloak
                  ></el-table-column>
                </el-table>
              </div>
              <div class="add-post-paging text-right">
                <el-pagination
                  background
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="parseInt(paging.addPost.totalNum)"
                  :page-sizes="[10, 20, 30, 50, 100]"
                  :pager-count="5"
                  @size-change="addPostSizeChange"
                  @current-change="addPostCurrentChange"
                  :current-page="paging.addPost.index"
                ></el-pagination>
              </div>
              <div slot="footer" class="dialog-footer">
                <div class="add-post-footer">
                  <el-button @click="cancelAddPost">取消</el-button>
                  <el-button type="primary" @click="addPostList" :loading="isSaveMember">保存</el-button>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>
      <el-dialog
        class="permission-blacklist-dialog-relieve"
        :visible.sync="relieveDialogVisible"
        width="25%"
        center
        :close-on-click-modal="false"
        :close-on-press-escape="false">
        <div class="permission-relieve-center">您是否解除黑名单？</div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="relieveDialogVisible = false;addDialogData.deleteId = ''" type="primary">取消</el-button>
          <el-button @click="relieveBlackItemClick">确定</el-button>
        </div>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
import { rolePowerMixin } from '@/components/system/users/usersMixin'
const addPostColumnData = [
  {
    prop: 'name',
    label: '岗位名称',
    resizable: false,
    align: 'center'
  },
  {
    prop: 'departmentName',
    label: '所属部门',
    resizable: false,
    align: 'center'
  },
  {
    prop: 'categoryName',
    label: '所属分类',
    resizable: false,
    align: 'center'
  }
]
export default {
  name: 'permission-blacklist',
  mixins: [rolePowerMixin],
  data () {
    return {
      keyWord: '',
      columns: [
        {
          prop: 'name',
          label: '权限名称'
        }, {
          prop: 'forbidTarget',
          label: '禁止对象'
        },
        {
          prop: 'createdTime',
          label: '创建时间'
        }, {
          prop: 'lastModifiedTime',
          label: '最近更新时间'
        }
      ],
      data: [],
      pagination: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      loadingBlackList: false,
      loadingMenu: false,
      loading2: false,
      addDialogVisible: false,
      saveBlacklistLoading: false,
      addDialogData: {
        deleteId: '', // 解除黑名单id
        title: '',
        menuData: '',
        personData: '',
        id: '', // 黑名单id
        menuCheckedList: [], // 选中的权限菜单
        checkedTableId: '', // 选中的岗位id
        forbidTargetType: '', // 选择的成员类型
        forbidTargetId: '' // 选择的成员id
      },
      selectId: '',
      menuDialogVisible: false,
      openMenu: true, // 默认打开菜单权限
      isSelectingParent: false,
      filterMenuText: '', // 筛选权限名称的关键字
      menuListObj: [], // 权限菜单
      menuTreeProps: {
        children: 'children',
        label: 'name',
        disabled: this.disableMenuSelect
      },
      menuCheckedList: [], // 选中的菜单
      disabledMenuListId: [], // 禁用的选项
      personDialogVisible: false,
      activeTabName: 'people&department',
      pdSelectedId: [], // 选中的人员/部门的id
      filterText: '', // 筛选人员/部门的关键字
      nodeList: [], // 人员/部门tree数据
      defaultProps: {
        children: 'children',
        label: 'name',
        disabled: this.disableAlreadySelect // 禁用复选框
      },
      // 选择的人员
      peopleSelected: [],
      // 选择的部门
      departmentSelected: [],
      postClissifyList: [], // 所属分类下拉框数据
      isSaveMember: false, // 添加成员弹窗内的保存按钮是否loading
      formData: {
        addPostFormData: {
          isLoadPosts: false, // 岗位表格数据是否loading
          name: '', // 岗位关键字
          category: '' // 所属分类
        }
      },
      tableData: {
        addPostData: [], // 岗位表格数据
        addPostColumnData
      },
      paging: {
        addPost: {
          totalNum: 0,
          index: 1,
          size: 10
        }
      },
      checkPost: [], // 选择的岗位
      relieveDialogVisible: false
    }
  },
  mounted () {
    this.search()
  },
  methods: {
    disableMenuSelect (data, id) {
      return this.disabledMenuListId.includes(data.id)
    },
    search (isManual) {
      if (isManual) {
        // 手动点查询时返回第一页
        this.pagination.currentPage = 1
      }
      let params = {
        index: this.pagination.currentPage,
        size: this.pagination.pageSize,
        sort: '',
        order: '',
        filters: {
          name: this.keyWord
        }
      }
      this.loadingBlackList = true
      this.$axios.get('/auth-api/authority/black/list', {params}).then(res => {
        this.data = res.data.items
        this.pagination.total = res.data.total
        this.loadingBlackList = false
      }).catch(() => {
        this.loadingBlackList = false
      })
    },
    // 添加黑名单
    add (isManual) {
      this.addDialogData.title = '添加黑名单'
      this.addDialogVisible = true
    },
    // 设置黑名单
    setupClick (scope, row) {
      this.addDialogData.title = '添加黑名单'
      this.menuCheckedList = row.menuList
      this.addDialogData.menuData = row.name
      this.addDialogData.personData = row.forbidTarget
      this.addDialogData.id = row.id
      this.addDialogData.menuCheckedList = row.menuList
      this.addDialogData.forbidTargetType = row.forbidTargetType
      this.addDialogData.forbidTargetId = row.forbidTargetId
      if (row.forbidTargetType === 'user') {
        this.peopleSelected = [{
          id: row.forbidTargetId,
          name: row.forbidTarget,
          groupType: '人员'
        }]
        this.pdSelectedId.push(row.forbidTargetId)
      } else if (row.forbidTargetType === 'department') {
        this.departmentSelected = [{
          id: row.forbidTargetId,
          name: row.forbidTarget,
          groupType: '部门'
        }]
        this.pdSelectedId.push(row.forbidTargetId)
      } else if (row.forbidTargetType === 'post') {
        this.addDialogData.checkedTableId = row.forbidTargetId
      }
      this.addDialogVisible = true
    },
    // 解除黑名单
    relieveDialogClick (scope, row) {
      this.addDialogData.deleteId = row.id
      this.relieveDialogVisible = true
    },
    // 打开添加权限弹窗,并选中选择的菜单
    addMenu () {
      this.menuDialogVisible = true
      this.loading2 = true
      !this.menuListObj.length && (this.loadingMenu = true) && this.$axios.get(`/auth-api/roles/getRoleMenuList?menuType=menu`).then(res => {
        this.menuListObj = res.data
        this.$nextTick(() => {
          if (this.menuCheckedList.length) {
            this.$refs['menuTree'].setChecked(this.menuCheckedList[0].id, true)
          }
        })
        this.loading2 = false
        this.loadingMenu = false
      }).catch(() => {
        this.loading2 = false
        this.loadingMenu = false
      })
      this.loading2 = false
      this.$nextTick(() => {
        if (this.menuCheckedList.length) {
          this.$refs['menuTree'].setChecked(this.menuCheckedList[0].id, true, true)
          if (this.menuCheckedList[0].children && this.menuCheckedList[0].children.length && this.menuCheckedList[0].children[0].functionType === '5') {
            this.disabledMenuListId = this.menuCheckedList[0].children.map(e => e.id)
          }
        }
      })
    },
    // 选择权限菜单 废弃
    handleMenuCheckedGiveUp (data, checked) {
      if (!checked.checkedKeys.length) {
        this.menuCheckedList = []
        this.addDialogData.menuData = ''
      } else if (checked.checkedKeys.length > 1) {
        if (this.menuCheckedList.length) {
          this.$message.warning('只能选择一个菜单！')
        } else {
          this.$message.warning('只能选择一个子菜单！')
        }
        this.$refs['menuTree'].setChecked(data, false, true)
      } else {
        if (this.menuCheckedList.length) {
          this.$message.warning('只能选择一个菜单！')
          // 去除选中项
          if (data.children && data.children.length === 0) {
            // 子节点
            this.$refs['menuTree'].setChecked(data, false)
          } else {
            // 父节点
            this.$refs['menuTree'].setChecked(data, false, true)
          }
        } else {
          if (data.children && data.children.length === 0) {
            this.menuCheckedList.push(data)
          } else {
            this.$message.warning('只能选择一个子菜单！')
            this.$refs['menuTree'].setChecked(data, false, true)
          }
        }
      }
    },
    // 选择权限菜单
    handleMenuChecked (data, checked) {
      if (data.functionType === '5') {
        this.$refs['menuTree'].setChecked(data.id, false, true)
        return this.$message.warning('不能选择一个功能性菜单！')
      }
      if (checked.checkedKeys.includes(data.id)) {
        // 当前菜单是选中状态
        if (data.children.length && data.children[0].functionType !== '5') {
          this.$refs['menuTree'].setChecked(data.id, false, true)
          return this.$message.warning('只能选择一个子菜单！')
        }
        // 已选中一个菜单，选择另一个菜单
        if (this.menuCheckedList.length && this.menuCheckedList.id !== data.id) {
          this.disabledMenuListId = []
          this.$refs['menuTree'].setChecked(this.menuCheckedList[0].id, false, true)
          this.menuCheckedList = [data]
          this.addDialogData.menuData = data.name
          if (data.children.length && data.children[0].functionType === '5') {
            this.disabledMenuListId = data.children.map(e => e.id)
          }
        } else {
          // 无选中一个菜单，选择一个菜单
          this.menuCheckedList.push(data)
          this.addDialogData.menuData = data.name
          if (data.children.length && data.children[0].functionType === '5') {
            this.disabledMenuListId = data.children.map(e => e.id)
          }
        }
      } else {
        // 当前菜单是未选中状态（此场景只存在于取消当前选中菜单）
        if (this.menuCheckedList.length) {
          this.disabledMenuListId = []
          this.$refs['menuTree'].setChecked(this.menuCheckedList[0].id, false, true)
          this.addDialogData.menuData = ''
          if (data.id !== this.menuCheckedList[0].id) {
            this.menuCheckedList.push(data)
            this.addDialogData.menuData = data.name
            if (data.children.length && data.children[0].functionType === '5') {
              this.disabledMenuListId = data.children.map(e => e.id)
            }
          }
          this.menuCheckedList = []
        }
      }
    },
    // 筛选菜单权限
    filterNodeMenu (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 保存菜单权限
    saveMenuClick () {
      // 如果还在加载中禁止保存
      if (this.loadingMenu) {
        return this.$message.warning('数据加载中, 请稍候')
      }
      if (!this.menuCheckedList.length) {
        return this.$message.warning('请至少选择一个菜单！')
      }
      this.addDialogData.menuCheckedList = this.menuCheckedList
      this.addDialogData.menuData = this.menuCheckedList[0].name
      this.filterMenuText = ''
      this.menuDialogVisible = false
    },
    // 取消添加权限菜单
    cancelAddMenu () {
      if (!this.addDialogData.id && !this.addDialogData.menuData) {
        // 新建黑名单
        if (this.menuCheckedList.length) {
          this.$refs['menuTree'].setChecked(this.menuCheckedList[0].id, false, true)
          this.menuCheckedList = []
        }
      }
      if (this.addDialogData.menuCheckedList.length) {
        if (this.menuCheckedList.length && this.menuCheckedList[0].id !== this.addDialogData.menuCheckedList[0].id) {
          this.disabledMenuListId = []
          this.$refs['menuTree'].setChecked(this.menuCheckedList[0].id, false, true)
        }
        this.menuCheckedList = this.addDialogData.menuCheckedList
        this.addDialogData.menuData = this.addDialogData.menuCheckedList[0].name
      }
      this.menuDialogVisible = false
      this.filterMenuText = ''
    },
    // 添加成员弹窗并选中选择的人员/部门/岗位
    addPerson () {
      this.personDialogVisible = true
    },
    // 获取人员/部门数据
    searchPD () {
      !this.nodeList.length && this.$axios.get(`/auth-api/departments/roleMemberTree`)
        .then(res => {
          this.nodeList = res.data ? res.data : []
        })
    },
    // 已经选中的禁用选择框
    disableAlreadySelect (data, node) {
      return this.pdSelectedId.includes(data.id)
    },
    // 人员/部门筛选
    filterNode (val, data) {
      if (!val) return true
      return data.name && data.name.indexOf(val) !== -1
    },
    // 选择人员/部门
    dialogNodeClick (node, state) {
      // 不需要子节点数据
      delete node.children
      if (node.type === 'department') {
        node.groupType = '部门'
        // 如果是勾选
        if (state) {
          if (this.pdSelected.length || this.checkPost.length) {
            this.$refs['dialogTree'].setChecked(node.id, false)
            return this.$message.warning('只能选择一个人员、部门或岗位！')
          }
          this.departmentSelected.push(node)
          // 如果不存在已选择id列表中要放入
          if (!this.pdSelectedId.includes(node.id)) {
            this.pdSelectedId.push(node.id)
          }
        }
      } else if (node.type === 'user') {
        node.groupType = '人员'
        if (state) {
          if (this.pdSelected.length || this.checkPost.length) {
            this.$refs['dialogTree'].setChecked(node.id, false)
            return this.$message.warning('只能选择一个人员、部门或岗位！')
          }
          this.peopleSelected.push(node)
          // 如果不存在已选择id列表中要放入
          if (!this.pdSelectedId.includes(node.id)) {
            this.pdSelectedId.push(node.id)
          }
        }
      }
    },
    deleteInpdSelectedId (member) {
      let index = this.pdSelectedId.findIndex(e => e === member.id || e === member.memberId)
      if (index !== -1) {
        this.pdSelectedId.splice(index, 1)
      }
    },
    // 删除群组下的人员部门
    deleteRoleMember (member) {
      // 把他从已选择id列表中删掉
      this.deleteInpdSelectedId(member)
      // 从左侧列表中新加入的是没有memberId的，但是打开弹窗重新加载就会有，刚打开弹窗时右侧列表的memberId === 左侧列表的id
      if (member.groupType === '部门') {
        let index = this.departmentSelected.findIndex(m => m.memberId === member.memberId || m.memberId === member.id || m.id === member.id)
        this.departmentSelected.splice(index, 1)
      } else if (member.groupType === '人员') {
        let index = this.peopleSelected.findIndex(m => m.memberId === member.memberId || m.memberId === member.id || m.id === member.id)
        this.peopleSelected.splice(index, 1)
      }
      // 如果当前是选中状态，则取消其选中状态
      let currentCheckedKeys = this.$refs.dialogTree.getCheckedKeys()
      if (currentCheckedKeys.includes(member.memberId ? member.memberId : member.id)) {
        this.$refs.dialogTree.setCheckedNodes(currentCheckedKeys.filter(id => id !== member.memberId && id !== member.id))
      }
    },
    // 保存选择的人员/部门
    saveSelectedMember () {
      this.isSaveMember = true
      if (this.checkPost.length) {
        this.addDialogData.personData = this.checkPost[0].name
        this.isSaveMember = false
        this.cancelAddPost()
        return
      }
      if (this.$refs.dialogTree.getCheckedKeys().length > 0) {
        this.addDialogData.personData = this.pdSelected[0].name
        this.isSaveMember = false
        this.cancelAddMember()
      } else {
        this.$message({
          message: '请至少选择一个人员、部门或岗位再保存',
          type: 'error'
        })
      }
      this.isSaveMember = false
    },
    // 关闭添加成员的弹窗
    cancelAddMember () {
      this.personDialogVisible = false
    },
    // 添加成员弹窗切换tab
    handleTabChange (tab) {
      if (tab.name === 'post' && tab.active) {
        // this.$refs.postTable.clearSelection()
        !this.tableData.addPostData.length && this.getPostList()
      }
    },
    // 去掉岗位表的全选
    cellClass (row) {
      if (row.columnIndex === 0) {
        return 'DisableSelection'
      }
    },
    // 获取岗位列表
    getPostList () {
      this.formData.addPostFormData.isLoadPosts = true
      this.tableData.addPostData = []
      let params = {
        index: this.paging.addPost.index,
        size: this.paging.addPost.size
      }
      params.filters = {
        name: this.formData.addPostFormData.name,
        categoryId: this.formData.addPostFormData.category
      }
      this.$nextTick(() => {
        this.$axios.get(`/auth-api/posts`, {params}).then(res => {
          this.formData.addPostFormData.isLoadPosts = false
          this.tableData.addPostData = res.data.items || []
          res.data.total && res.data.items.forEach((item, index) => {
            if (this.addDialogData.checkedTableId === item.id) {
              this.$refs.postTable.toggleRowSelection(this.tableData.addPostData[index])
              this.checkPost = [item]
            }
          })
          this.paging.addPost.totalNum = res.data.total
          this.getPostClissifyList()
        })
      })
    },
    // 获取岗位的所属分类
    getPostClissifyList () {
      this.$axios.get(`/auth-api/organization/getPostCategories`).then(res => {
        this.postClissifyList = res.data || []
      })
    },
    // 查询岗位列表
    searchAddPostList () {
      this.formData.addPostFormData.name = this.formData.addPostFormData.name.replace(
        /(^\s*)|(\s*$)/g,
        ''
      )
      this.paging.addPost.index = 1
      this.$nextTick(() => {
        this.$refs.postTable.clearSelection()
        this.getPostList()
      })
    },
    // 岗位表复选框选择
    handleSelectionChange (val, row) {
      if (this.pdSelected.length) {
        this.$refs.postTable.toggleRowSelection(row, false)
        this.$message.warning('只能选择一个人员、部门或岗位！')
      } else if (this.checkPost.length) {
        if (this.checkPost[0].id !== row.id) {
          this.$message.warning('只能选择一个人员、部门或岗位！')
        } else {
          this.checkPost = []
        }
        this.$refs.postTable.toggleRowSelection(row, false)
      } else {
        this.checkPost = val
        this.addDialogData.checkedTableId = val.id
      }
    },
    // 岗位表单击行
    handleRowClick (row, column, event) {
      this.handleSelectionChange([row], row)
    },
    // 修改数量
    addPostSizeChange (val) {
      this.paging.addPost.index = 1
      this.paging.addPost.size = val
      this.$nextTick(() => {
        this.$refs.postTable.clearSelection()
        this.getPostList()
      })
    },
    // 修改页码
    addPostCurrentChange (val) {
      this.paging.addPost.index = val
      this.$nextTick(() => {
        this.$refs.postTable.clearSelection()
        this.getPostList()
      })
    },
    // 保存岗位列表
    addPostList () {
      this.isSaveMember = true
      if (this.$refs.dialogTree.getCheckedKeys().length > 0) {
        this.addDialogData.personData = this.pdSelected[0].name
        this.isSaveMember = false
        this.cancelAddPost()
        return
      }
      if (this.checkPost.length === 0) {
        this.isSaveMember = false
        return this.$message.error('请至少选择一个人员、部门或岗位再保存')
      }
      this.addDialogData.personData = this.checkPost[0].name
      this.isSaveMember = false
      this.cancelAddPost()
    },
    // 取消保存岗位
    cancelAddPost () {
      // this.$refs.postTable.clearSelection()
      // this.checkPost = []
      this.formData.addPostFormData.name = ''
      this.formData.addPostFormData.category = ''
      this.personDialogVisible = false
    },
    savePersonClick () {
      //
    },
    // 分页
    handleCurrentChange (val) {
      this.pagination.currentPage = val
      this.search()
    },
    handleSizeChange (val) {
      this.pagination.pageSize = val
      this.search()
    },
    // 不添加黑名单,弹窗内数据清空
    cancleAdd () {
      this.menuCheckedList = []
      this.menuListObj = []
      this.nodeList = []
      this.peopleSelected = []
      this.departmentSelected = []
      this.pdSelectedId = []
      this.activeTabName = 'people&department'
      // this.$refs.postTable.clearSelection()
      this.checkPost = []
      this.tableData.addPostData = []
      this.paging.addPost.totalNum = 0
      this.paging.addPost.index = 1
      this.paging.addPost.size = 10
      this.addDialogData.menuData = ''
      this.addDialogData.personData = ''
      this.addDialogData.id = ''
      this.addDialogData.menuCheckedList = []
      this.addDialogData.checkedTableId = ''
      this.addDialogData.forbidTargetType = ''
      this.addDialogData.forbidTargetId = ''
      this.addDialogVisible = false
    },
    // 保存添加的黑名单
    saveBlacklistClick () {
      this.saveBlacklistLoading = true
      if (this.addDialogData.menuData === '' || this.addDialogData.personData === '') {
        this.saveBlacklistLoading = false
        return this.$message.warning('请先选择权限菜单和禁止对象再保存！')
      } else {
        let forbidTargetType = this.addDialogData.forbidTargetType
        let forbidTargetId = this.addDialogData.forbidTargetId
        if (this.peopleSelected.length) {
          forbidTargetType = 'user'
          forbidTargetId = this.peopleSelected[0].id
        } else if (this.departmentSelected.length) {
          forbidTargetType = 'department'
          forbidTargetId = this.departmentSelected[0].id
        } else if (this.checkPost.length) {
          forbidTargetType = 'post'
          forbidTargetId = this.checkPost[0].id
        }
        let params = {
          name: this.addDialogData.menuData, // 权限菜单名称
          forbidTarget: this.addDialogData.personData, // 禁止对象名称
          forbidTargetType: forbidTargetType, // 禁止的类型
          forbidTargetId: forbidTargetId, // 禁止的id
          menuList: this.menuCheckedList
        }
        if (this.addDialogData.id) {
          params.id = this.addDialogData.id
        }
        this.$axios.post(`/auth-api/authority/black`, params).then(res => {
          if (this.addDialogData.id) {
            this.$message.success('更新成功！')
          } else {
            this.$message.success('新建成功！')
          }
          this.saveBlacklistLoading = false
          this.cancleAdd()
          this.search(true)
        }).catch(() => {
          this.saveBlacklistLoading = false
        })
      }
    },
    // 解除黑名单
    relieveBlackItemClick () {
      this.$axios.delete(`/auth-api/authority/black/${this.addDialogData.deleteId}`).then(res => {
        this.$message.success('解除成功')
        this.relieveDialogVisible = false
        this.addDialogData.deleteId = ''
        this.search(true)
      }).catch(() => {
        this.relieveDialogVisible = false
        this.addDialogData.deleteId = ''
      })
    }
  },
  computed: {
    // 选中的人员/部门
    pdSelected () {
      return this.$_.concat(this.departmentSelected, this.peopleSelected)
    },
    // 菜单权限中需要展开的节点
    getExpandedKey () {
      return this.menuCheckedList.length ? [this.menuCheckedList[0].id] : []
    }
  },
  watch: {
    // 权限菜单筛选
    filterMenuText (val) {
      this.$refs.menuTree.filter(val)
    },
    // 人员/部门筛选
    filterText (val) {
      this.$refs.dialogTree && this.$refs.dialogTree.filter(val)
    },
    // 加载人员/部门数据
    'personDialogVisible' (val) {
      // 打开弹窗时请求所有部门数据
      if (val) {
        this.searchPD()
      }
      if (!val) {
        this.filterText = ''
      }
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/common.scss';

  .el-container.permission-blacklist {
    font-size: 12px;
    .permission-blacklist-search {
      padding: 14px 24px;
      .el-input, div {
        width: 240px!important;
      }
      .button-border{
        margin-left: 20px;
        border: 1px solid var(--primary, #55ACF1);
        color: var(--primary, #55ACF1);
        padding: 5px;
        vertical-align: middle;
      }
      .button-solid {
        position: absolute;
        top: 20px;
        right: 24px;
        vertical-align: middle;
        background-color: var(--primary, #55ACF1);
        color: #fff;
      }
    }
    .log-table{
      height: 100%;
      padding: 0;
      .el-table.table-list{
        border-left: 0;
        .gray-text-button {
          color: #B0AFAF;
          margin-left: 8px;
          cursor: pointer;
        }
        .blue-text-button {
          color: var(--primary, #409EFF);
          margin-left: 8px;
          cursor: pointer;
        }
        .gray-text-button:hover {
          color: var(--primary, #409EFF)
        }
      }
    }
    .el-main .content .el-input .el-input__inner{
      height: 26px;
      line-height: 26px;
    }
    .permission-blacklist-dialog {
      .el-dialog__body {
        .add-blacklist {
          padding: 0 10px;
          span {
            margin-right: 20px;
            text-overflow: ellipsis;
          }
          .el-button {
            text-decoration:underline
          }
        }
      }
      .el-dialog__footer>.dialog-footer {
        padding: 0 130px;
        display: flex;
        justify-content: space-between;
        .permission-blacklist-button {
          background-color: var(--primary, #55ACF1);
          color: #fff;
        }
      }
    }
    .permission-blacklist-menu-dialog {
      .permission-blacklist-search-input {
        margin-bottom: 12px;
      }
      .el-dialog__body {
        .permission-blacklist-divide {
          border-bottom: 1px solid #EDF2F5;
          padding: 0 0 10px 0;
          span {
            margin-left: 5px;
          }
        }
        .el-tree {
          max-height: 450px;
          overflow: auto;
        }
      }
    }
    .permission-blacklist-person-dialog {
      .el-dialog--center .el-dialog__body {
        padding: 0;
        .el-tabs {
          border: 0;
          box-shadow: none;
          .el-tabs__nav {
            margin-left: 10px;
            margin-bottom: 10px;
            #tab-first, #tab-second {
              position: relative;
              font-size: 14px;
              &::after {
                content: "";
                display: inline-block;
                width: 1px;
                height: 20px;
                position: absolute;
                top: 12px;
                right: 1px;
                background: #D2E0F4;
              }
            }
          }
          .el-tabs__header {
            background-color: #fff;
            border: 0;
            .el-tabs__item {
              height: 40px;
              line-height: 40px;
              color: #1A1A1A;
            }
            .is-active {
              background-color: inherit;
              border-right-color: #fff;
              border-left-color: #fff;
              border-bottom-width: 2px;
              border-bottom-color: var(--primary, #409EFF);
              color: var(--primary, #409EFF);
            }
            div, span, p {
              user-select: none;
            }
          }
          .el-tabs__content {
            padding: 0 10px;
            // padding-left: 15px;
            // padding-right: 15px;
          }
          .people-department-content{
            .pd-content{
              display: flex;
              width: 100%;
              height: 460px;
              border: 1px solid #C2C3C4;
              border-radius: 4px;
              padding: 14px;
              padding-right: 0;
              .pd-content-left,.pd-content-right{
                flex: 1 1 50%;
              }
              .pd-content-left{
                border-right: 1px solid #C2C3C4;
                .pd-content-left-search{
                  .el-input{
                    width: 95%;
                  }
                }
                .el-tree{
                  height: calc(100% - 30px);
                  overflow: scroll;
                }
              }
              .pd-content-right{
                .pd-content-title{
                  text-align: center;
                  h4{
                    line-height: 60px;
                    color: #232323;
                    font-weight: 400;
                  }
                }
                .show-select-label{
                  p{
                    margin: 5px 0;
                    padding: 0 10px 0 20px;
                    color: #2A2929;
                    line-height: 22px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    &:nth-of-type(even){
                      background: var(--light-9, #ECF5FB);
                    }
                    i{
                      color: #CBCBCB;
                      margin-right: 13px;
                    }
                    i.el-icon-error{
                      cursor: pointer;
                      float: right;
                      &:hover{
                        color: #FB9391;
                      }
                      &:active{
                        color: #EE5757;
                      }
                    }
                  }
                }
              }
            }
          }
          .post-content {
            .el-form .el-form-item{
              .el-input input{
                max-width: 155px;
              }
            }
            .add-post-search {
              margin: 0 10px;
            }
            .add-post-table {
              .el-table .DisableSelection .cell .el-checkbox__inner{
                display: none;
                position: relative;
              }
              .el-table .DisableSelection .cell:before{
                content: "";
                position: absolute;
              }
            }

            .add-post-paging {
              padding-top: 10px;
              .el-pagination{
                overflow-x: scroll;
              }
            }

            .add-post-footer {
              text-align: center;
            }
            .change-border-color {
              border-color: var(--primary, #62A8F2);
              color: var(--primary, #62A8F2);
            }
          }
        }
      }
      .el-dialog{
        min-width: 510px;
      }
      .dialog-footer{
        padding: 7px 0;
        text-align: center;
      }

      .custom-tree
      .is-current
      > .el-tree-node__content
      > .el-tree-node__label {
        color: #606266;
      }
    }
    .permission-blacklist-dialog-relieve {
      .el-dialog__header{
        background-color: #fff;
      }
      .el-dialog__body {
        .permission-relieve-center {
          padding: 20px 0 0 0;
          text-align: center;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/system/system/permission-blacklist.vue